// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2_QYj","errorLogs":"styles_errorLogs__1dQBG"};